export default {
  title: "Druid",
  content: [
    "Tiger’s Fury replaced with Feral Fury: now increases the damage of your next ability while in cat or bear form by 25% and generates 10 rage or 30 energy. 30 sec cooldown.",
    "Faerie Fire (Feral) is now a baseline ability.",
    "Hurricane is now a 3 sec cast instead of channeled.",
    "Swipe now scales with attack power.",
    "Frenzied Regeneration now heals based on the druid's total health.",
    "Rejuvenation and Regrowth spells can now be active on targets affected by another Druid's Rejuvenation or Regrowth.",
    "Cat Form now has a separate action bar when prowling.",
  ],
};
